<template>
  <SlideIn
    :open="isOpen"
    heading="Account"
    :content-padding="false"
    @close="isOpen = false"
  >
    <template #content>
      <div class="account__wrapper">
        <template v-if="!showForgottenPassword">
          <div class="container">
            <Tabs>
              <Tab name="Login to your account">
                <SingleSignOn />
                <LoginForm @success="handleLoginSuccess" />
                <div class="forgotten-password-button">
                  <Button
                    type="button"
                    width="full"
                    theme="secondary"
                    @click="showForgottenPassword = true"
                  >
                    Forgotten password?
                  </Button>
                </div>
              </Tab>
              <Tab name="New customer?">
                <RegisterPanel />
              </Tab>
            </Tabs>
          </div>
        </template>

        <AccountRecovery v-if="showForgottenPassword" />
      </div>
    </template>
  </SlideIn>
</template>

<script>
import AccountRecovery from "@/components/account/AccountRecovery.vue";
import { mapActions, mapState } from "vuex";

import LoginForm from "@/components/account/LoginForm.vue";
import RegisterPanel from "@/components/account/RegisterPanel.vue";
import Button from "@/components/ButtonV3.vue";
import SingleSignOn from "@/components/SingleSignOn.vue";
import SlideIn from "@/components/SlideIn.vue";
import Tab from "@/components/Tab.vue";
import Tabs from "@/components/Tabs.vue";

export default {
  name: "LoginPanel",
  components: {
    LoginForm,
    AccountRecovery,
    Tabs,
    Tab,
    RegisterPanel,
    SingleSignOn,
    Button,
    SlideIn,
  },
  emits: ["update:open"],
  data() {
    return {
      open: false,
      showForgottenPassword: false,
    };
  },
  computed: {
    ...mapState("app", ["isAccountOpen"]),
    ...mapState("auth", ["multipassAccount"]),
    isOpen: {
      get() {
        return this.isAccountOpen;
      },
      set(val) {
        return this.setAccountOpen(val);
      },
    },
  },
  methods: {
    ...mapActions("app", ["setAccountOpen"]),
    handleLoginSuccess() {
      window.location.href = this.multipassAccount.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.account__wrapper {
  padding: 20px 0 30px;
}

.forgotten-password-button {
  margin-top: 10px;
}
</style>
